import {APP_INITIALIZER, Component, ErrorHandler, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import * as Sentry from "@sentry/angular";
import {DATE_PIPE_DEFAULT_OPTIONS} from "@angular/common";
import {Title} from "@angular/platform-browser";
import {Content, HeaderService} from "./shared-module/services/header.service";
import {SettingService} from "./shared-module/services/setting.service";
import {ApplicationSettings} from "./shared-module/interfaces/settings.interface";
import {config} from "../config";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: true,
            }),
        }, {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: {
                dateFormat: 'dd-MM-yyyy HH:mm'
            },
        },
        {
            provide: APP_INITIALIZER,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            useFactory: () => () => {
            },
            deps: [Sentry.TraceService],
            multi: true,
        },
    ],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {

  public companyFlavor: string = config.appName;
  private headerService = inject(HeaderService);
  private titleService = inject(Title);
  private settingService = inject(SettingService);

  public ngOnInit() {
      this.settingService.settings.subscribe((settings: ApplicationSettings | null) => {
        if (settings) {
          this.companyFlavor = config.appName;
          this.titleService.setTitle(this.companyFlavor);
        }
      });

    this.headerService.content().subscribe((content: Content) => {
      if (content.title) {
        this.titleService.setTitle(`${this.companyFlavor} - ${content.title}`);
      }
    });
  }
}
